module.exports = __webpack_public_path__ + "static/media/TH.1d53e378.svg";